import { ValidatorAndMessage, ValidatorFunction } from './ValidationTypes';

export namespace Validator {
  // Validators

  const validateRequired = (value: any): boolean => {
    if (value === 0) {
      return true;
    }
    // handle string
    if (value && value !== '' && !Array.isArray(value)) {
      return true;
    }
    // handle array
    if (value && Array.isArray(value) && value.length > 0) {
      return true;
    }

    return false;
  };

  const validateInt = (value: number) => {
    if (value) {
      return value % 1 === 0;
    }
    return true;
  };

  const validatePattern = (value: string, regex: RegExp): boolean => (value ? regex.test(value) : true);

  export function int(): ValidatorFunction {
    return (value: number) => validateInt(value);
  }

  export function required(): ValidatorFunction {
    return (value: any) => validateRequired(value);
  }

  export function isTrue(): ValidatorFunction {
    return (value: boolean) => value === true;
  }

  export function requiredStringKey<T>(...ts: T[]): ValidatorFunction {
    return (value: T) => validateRequired(value) && ts.includes(value);
  }

  export function pattern(regex: RegExp): ValidatorFunction {
    return (value: string) => validatePattern(value, regex);
  }

  export function email(): ValidatorFunction {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return value => re.test(value.toLowerCase());
  }
}

export const requiredTrueValidator = (message = 'Value must be true'): ValidatorAndMessage => {
  return {
    validate: Validator.isTrue(),
    message,
  };
};

export const requiredTextInputValidator: ValidatorAndMessage = {
  validate: Validator.required(),
  message: 'Please enter a value',
};

export const requiredNumericInputValidator: ValidatorAndMessage = {
  validate: Validator.required(),
  message: 'Please enter a numeric value',
};

export const patternValidator = (exp: RegExp, message: string): ValidatorAndMessage => {
  return {
    validate: Validator.pattern(exp),
    message,
  };
};

export const requiredEmailValidator: ValidatorAndMessage = {
  validate: Validator.email(),
  message: 'Please enter a valid email',
};
